import { DateTime } from "luxon"

// ART-3199: planned downtime for the PostgreSQL upgrade. Times are UK local
// (Europe/London), matching how the window was announced to customers. The
// notice shows from release until `hideAfter`, which leaves an hour of slack
// after the window in case the work overruns. To announce a future window,
// update these three times and the copy below.
//
// The notice runs on the viewer's clock, not on the upgrade's status: it hides
// at `hideAfter` even if the work is still going, and it stays up if the work
// is cancelled. Either case needs a redeploy.
const MAINTENANCE_ZONE = "Europe/London"
export const startsAt = DateTime.fromISO("2026-09-25T16:00", { zone: MAINTENANCE_ZONE, locale: "en-GB" })
export const endsAt = DateTime.fromISO("2026-09-25T17:00", { zone: MAINTENANCE_ZONE, locale: "en-GB" })
export const hideAfter = DateTime.fromISO("2026-09-25T18:00", { zone: MAINTENANCE_ZONE, locale: "en-GB" })

export const MAINTENANCE_DETAIL =
    "We're upgrading our database. Route Reports may be unavailable for part of this window — we expect around 30 minutes. " +
    "Pages may fail to load or save during this time; please refresh once the work is complete."

// "4", "4:30", "4pm", "4:30pm"
const formatTime = (time: DateTime, withMeridiem: boolean) =>
    `${time.toFormat(time.minute ? "h:mm" : "h")}${withMeridiem ? time.toFormat("a").toLowerCase() : ""}`

// e.g. "Fri 25 Sept, 4–5pm UK time" (en-GB abbreviates September as "Sept").
// The start keeps its own am/pm only when it differs from the end's: "11am–1pm".
export const formatWindowLabel = (start: DateTime, end: DateTime) => {
    const sameMeridiem = start.toFormat("a") === end.toFormat("a")
    return `${start.toFormat("ccc d LLL")}, ${formatTime(start, !sameMeridiem)}–${formatTime(end, true)} UK time`
}

export type MaintenanceNoticeContent = {
    headline: string
    summary: string
    windowLabel: string
}

// null once the notice should be gone.
export const getMaintenanceNotice = (now: DateTime): MaintenanceNoticeContent | null => {
    if (now >= hideAfter) return null
    const inProgress = now >= startsAt
    return {
        headline: inProgress ? "Maintenance in progress" : "Planned maintenance",
        summary: inProgress ? "some pages may be unavailable" : "brief downtime expected",
        windowLabel: formatWindowLabel(startsAt, endsAt),
    }
}
